module.exports = __webpack_public_path__ + "img/36908-021.8fbb81ae.jpg";